import { Box, Typography, Table, TableBody, TableCell, TableHead, TableRow, Chip } from '@mui/material';
import type { ChipColor } from '@/types/chip';
import { School } from '@mui/icons-material';
import { TRAINING_STATUS_COLORS } from './constants';

interface TrainingRecord {
  id?: string;
  courseName?: string;
  provider?: string;
  startDate?: string;
  status?: string;
  cost?: { amount?: number } | number;
  [key: string]: unknown;
}

interface EmployeeTrainingProps {
  records: TrainingRecord[];
}

export const EmployeeTraining = ({ records }: EmployeeTrainingProps) => (
  <Box>
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
      <School color="primary" />
      <Typography variant="subtitle1" fontWeight={700}>Training History</Typography>
      <Chip label={`${records.length} records`} size="small" sx={{ ml: 1 }} />
    </Box>
    {records.length > 0 ? (
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>Course</TableCell>
            <TableCell>Provider</TableCell>
            <TableCell>Start Date</TableCell>
            <TableCell>Status</TableCell>
            <TableCell>Cost</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {records.map(t => (
            <TableRow key={t.id}>
              <TableCell>{t.courseName}</TableCell>
              <TableCell>{t.provider}</TableCell>
              <TableCell>{t.startDate}</TableCell>
              <TableCell><Chip label={t.status} size="small" color={TRAINING_STATUS_COLORS[t.status ?? ''] as ChipColor} /></TableCell>
              <TableCell>R {typeof t.cost === 'object' && t.cost?.amount != null ? Number(t.cost.amount).toLocaleString() : (typeof t.cost === 'number' ? t.cost.toLocaleString() : '—')}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    ) : (
      <Typography variant="body2" color="text.secondary">No training records found</Typography>
    )}
  </Box>
);
